<template>
  <v-theme-provider>
    <div
      style="min-height:1000px"
    >
      <hero-forecast
        :forecast="forecast"
        :error="error"
      />
      <v-overlay
        :value="loading"
      >
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-overlay>
      <interior-band-photo
        v-if="!forecast && !fips && !apn && !propertyId && !address"
      />
      <about-us-2
        v-if="!forecast && !fips && !apn && !propertyId && !address"
      />
      <search-box-cta
        v-if="forecast"
        :forecast="forecast"
        :user="user"
      />
      <icon-box-band
        v-if="forecast"
        :forecast="forecast"
      />
      <!-- Service Providers -->
      <service-providers
        v-if="forecast"
        :forecast="forecast"
        :user="user"
      />
      <forecast-band1
        v-if="forecast && forecast.property_forecast"
        :forecast="forecast"
        :listings="listings"
        :user="user"
        :property="property"
        :walkscore="walkscore"
        :schools="schools"
        :option-lists="optionLists"
        :county-options="countyOptions"
        :county-options-multi="countyOptionsMulti"
      />
      <forecast-band2
        v-if="forecast"
        :forecast="forecast"
        :user="user"
        :stateZipCodeRankings="stateZipCodeRankings"
        :nationalZipCodeRankings="nationalZipCodeRankings"
        :statePropertyValueRankings="statePropertyValueRankings"
        :nationalPropertyValueRankings="nationalPropertyValueRankings"
      />
      <!-- Moving trends -->
      <forecast-band3
        v-if="forecast"
        :forecast="forecast"
        :user="user"
      />
      <!-- Competitive Score -->
      <!-- vx: && condition comes here (competitive) -->
      <forecast-band5
        v-if="forecast && forecast.property_forecast"
        :forecast="forecast"
        :user="user"
      />
      <!-- Rental Trends -->
      <forecast-band7
        v-if="forecast && forecast.property_forecast"
        :forecast="forecast"
        :user="user"
      />
      <!-- Comparable Properties -->
      <forecast-band6
        v-if="forecast && forecast.property_forecast"
        :forecast="forecast"
      />

      <!-- Honely Calculator -->
      <!-- <honely-calculator
        v-if="forecast && forecast.property_forecast"
        :forecast="forecast"
        :user="user"
        :property="property"
        :walkscore="walkscore"
        :schools="schools"
        :option-lists="optionLists"
        :county-options="countyOptions"
        :county-options-multi="countyOptionsMulti"
      /> -->

      <!-- Mortgage calculator -->
      <forecast-band4
        v-if="forecast && forecast.property_forecast"
        :forecast="forecast"
        :initial-value="initialValue"
        :user="user"
      />

      <!-- Report Form -->
      <report-form
        v-if="forecast"
        :forecast="forecast"
        :user="user"
        :property="property"
        :walkscore="walkscore"
        :schools="schools"
        :option-lists="optionLists"
      />
    </div>
  </v-theme-provider>
</template>

<script>
  /* eslint-disable */
  import axios from 'axios'
  import { mapGetters, mapState } from 'vuex'
  import { bus } from '../../main'

  export default {
    name: 'Forecast',
    props: ['rentalTrendData'],

    components: {
      HeroForecast: () => import('@/components/forecast/HeroForecast'),
      InteriorBandPhoto: () => import('@/components/forecast/InteriorBandPhoto'),
      AboutUs2: () => import('@/components/forecast/AboutUs2'),
      SearchBoxCta: () => import('@/components/forecast/SearchBoxCta'),
      IconBoxBand: () => import('@/components/forecast/IconBoxBand'),
      ForecastBand1: () => import('@/components/forecast/ForecastBand1'),
      ForecastBand2: () => import('@/components/forecast/ForecastBand2'),
      ForecastBand3: () => import('@/components/forecast/ForecastBand3'),
      ForecastBand4: () => import('@/components/forecast/ForecastBand4'),
      ForecastBand5: () => import('@/components/forecast/ForecastBand5'),
      ForecastBand6: () => import('@/components/forecast/ForecastBand6'),
      ForecastBand7: () => import('@/components/forecast/ForecastBand7'),
      ReportForm: () => import('@/components/forecast/ReportForm'),
      HonelyCalculator: () => import('@/components/forecast/HonelyCalculator'),
      ServiceProviders: () => import('@/components/forecast/ServiceProviders'),
    },

    data: () => ({
      user: null,
      fips: null,
      apn: null,
      propertyId: null,
      address: null,
      nationalZipCodeRankings: [],
      nationalPropertyValueRankings: [],
      stateZipCodeRankings: [],
      statePropertyValueRankings: [],
      // eslint-disable-next-line
      listingForDev: {"address":{"fips":"05007","apn":"16-39780-000","street_number":"9","street_pre_direction":"null","street_name":"NORWOOD","street_suffix":"LN","street_post_direction":"null","unit_type":"null","unit_number":"null","formatted_street_address":"9 NORWOOD LN","city":"BELLA VISTA","state":"AR","zip_code":"72714","zip_plus_four_code":"1849","latitude":"36.481077","longitude":"-94.247209","geocoding_accuracy":"PARCEL CENTROID","census_tract":"50070207.012014","carrier_code":"R048","full_address":"9 NORWOOD LN BELLA VISTA AR 72714 1849"},"tax":{"year":"2020","amount":"1263","exemptions":"HOMESTEAD","rate_code_area":"CBV6"},"valuation":{"year":"149000","amount":"125160","exemptions":"172840","forecast_standard_deviation":"16","date":"2021-03-03"},"structure":{"year_built":"null","effective_year_built":"null","stories":"1","rooms_count":"null","beds_count":"3","baths":"2","partial_baths_count":"null","units_count":"null","total_area_sq_ft":"1296.0","air_conditioning_type":"CENTRAL","amenities":"null","architecture_type":"null","basement_type":"null","condition":"null","construction_type":"FRAME","exterior_wall_type":"WOOD","flooring_types":"CARPET|TILE","foundation_type":"PIERS","heating_type":"CENTRAL","heating_fuel_type":"null","interior_wall_type":"null","other_rooms":"null","parking_type":"CARPORT","parking_spaces_count":"1.0","plumbing_fixtures_count":"null","pool_type":"null","quality":"C+","roof_material_type":"ASPHALT","roof_style_type":"null","sewer_type":"null","water_type":"null"}},
      forecast: null,
      competitive_score: 43,
      // eslint-disable-next-line
      forecastForDev: {"zipcode":"10021","state":"NY","property_forecast":{"fips":"36061","apn":"01384-1108","address":"15 E 69 ST # 9A NEW YORK NY 10021 4905","latitude":"40.770245","longitude":"-73.96684","list_price":"3090000","valuation":"3030022","appraised_value":"3088574","beds_count":"2","baths":"2","realtor":"Schwarz and Shah Reality","property_status":"For Sale","total_area_sq_ft":"3023","percentage_change_forecasts":[{"year":"May 2022","change":"5.61"},{"year":"May 2023","change":"7.48"},{"year":"May 2024","change":"9.13"}],"value_change_forecasts":[{"year":"May 2022","change":"3200000"},{"year":"May 2023","change":"3256800"},{"year":"May 2024","change":"3306809"}],"property_valued_compared_to_zipcode":"57.79"},"neighborhood":{"percentage_change_forecasts":[{"year":"May 2022","change":"-92.70"},{"year":"May 2023","change":"-91.65"},{"year":"May 2024","change":"-90.61"}],"value_change_forecasts":[{"year":"May 2022","change":"140248.85"},{"year":"May 2023","change":"160248.85"},{"year":"May 2024","change":"180248.85"}],"past_percentage_change":[{"year":"May 2020","change":"93.82"},{"year":"May 2019","change":"94.02"},{"year":"May 2021","change":"94.22"}],"zipcode_growth_state_ranking_forecasts":[{"year":"May 2021","rank":"10"}],"zipcode_growth_national_ranking_forecasts":[{"year":"May 2021","rank":"54"}],"total_state_rank":"256","total_national_rank":"2265","competitive_score":"59","competition_statements":"Some homes get multiple offers|The average homes sell for about 2% below list price and go pending in around 48 days.|Hot homes can sell for around list price and go pending in around 23 days.","last_30_days_median_list_price":"1503123.23","last_30_days_median_square_feet":"1200.45","last_30_days_median_sale_list":"1694313.89","last_30_days_total_homes_sold":"30"},"moving_trends":{"percentage_change_forecasts":[{"year":"May 2022","change":"1056383"}],"percentage_change_comparison_forecasts":[{"year":"May 2022","change":"24.34"}],"past_percentage_changes":[{"year":"May 2020","change":"-7.34"}],"past_percentage_changes_comparison":[{"year":"May 2022","rank":"53"}]}},
      error: null,
      initialValue: '0',
      property: null,
      walkscore: null,
      schools: [],
      optionLists: null,
      countyOptions: null,
      countyOptionsMulti: null,
      loading: false
    }),

    computed: {
      ...mapGetters('auth', ['loggedIn', 'username', 'vxAuth', 'vxAuthDependent', 'isCognitoUserLoggedIn', 'cognitoUser']),

      listings: function () {
        if (this.forecast && this.forecast.property_forecast) {
          return [{
            fips: this.forecast.property_forecast.fips,
            apn: this.forecast.property_forecast.apn,
            full_address: this.forecast.property_forecast.address,
            longitude: this.forecast.property_forecast.longitude,
            latitude: this.forecast.property_forecast.latitude,
            propery_value: this.forecast.property_forecast.valuation,
            beds_count: this.forecast.property_forecast.beds_count,
            baths: this.forecast.property_forecast.baths,
            total_area_sq_ft: this.forecast.property_forecast.total_area_sq_ft,
            for_sale: this.forecast.property_forecast.property_status,
            list_price: this.forecast.property_forecast.list_price,
            appraisal: this.forecast.property_forecast.appraisal,
            property_id: this.forecast.property_forecast.property_id,
            fainitiallistdate: this.forecast.property_forecast.posted_date,
            listingkey: this.forecast.property_forecast.listing_key,
          }]
        } else {
          return []
        }
      },
    },

    watch: {
      $route (to, from) {
        this.fips = this.$route.params.fips
        this.apn = this.$route.params.apn
        this.propertyId = this.$route.params.property_id
        this.address = this.$route.query.address
        this.load()
      },
    },

    mounted () {
      this.fips = this.$route.params.fips
      this.apn = this.$route.params.apn
      this.propertyId = this.$route.params.property_id
      this.address = this.$route.query.address
      if(this.$route.query.address){
        scrollTo({
        top: 300,
        behavior: 'smooth'
      })
      }
      if(this.$route.params.hasOwnProperty('property_id') === true){
        scrollTo({
        top: 300,
        behavior: 'smooth'
      })
      }
      this.load()
    },

    methods: {
      load () {
        // console.log('login status: ' + this.$store.getters['auth/isCognitoUserLoggedIn'])
        // console.log(this.user)
        
        if (this.$useDevVariables) {
          this.forecast = this.forecastForDev
          this.loading = false
          this.user = {
            user_id: null,
            first_name: 'Sample',
            last_name: 'Sample',
            email: null,
            phone_number: null,
            lookup_count: null,
            membership_type: null,
            blocked: null,
          }
        } else {
          // console.log('login status: ' + this.$store.getters['auth/isCognitoUserLoggedIn'])
          if (this.$store.getters['auth/isCognitoUserLoggedIn']) {
            // get current user
            axios.get('https://api.honely.com/lookup/user_profile', {
              params: {
                email: this.$store.getters['auth/cognitoUser'].attributes.email,
              },
            }).then((response) => {
              this.user = response.data
              // console.log(this.user)
            }).catch((error) => {
              console.log('[ERROR] Failed to fetch user data')
              console.log(error.response.data.errorMessage)
            })
          } else {
            // console.log('user is not logged in')
          }

          setTimeout(()=>{
            if (this.fips && this.apn) {
              this.loading = true
            // axios.get('https://api.honely.com/search/forecast', {
            // axios.get('https://api.honely.com/lookup/forecast', {
            axios.get('https://listhub.honely.com/locate/listhub_forecast', {
              params: {
                apn: this.apn,
                fips: this.fips,
                user_id: this.user.user_id,
              },
            }).then((response) => {
              this.loading = false
              this.forecast = response.data
              this.stateZipCodeRankings=[]
              this.statePropertyValueRankings=[]
              this.nationalZipCodeRankings=[]
              this.nationalPropertyValueRankings=[]
              for(var x=0; x< 4; x++) {
                this.stateZipCodeRankings.push(parseInt(this.forecast.neighborhood.zipcode_growth_state_ranking_forecasts[x].change))
                this.statePropertyValueRankings.push(parseInt(this.forecast.neighborhood.avg_value_state_ranking_forecasts[x].change))
                this.nationalZipCodeRankings.push(parseInt(this.forecast.neighborhood.zipcode_growth_national_ranking_forecasts[x].change))
                this.nationalPropertyValueRankings.push(parseInt(this.forecast.neighborhood.avg_value_national_ranking_forecasts[x].change))
              }
              if (this.forecast.property_forecast.property_id) {
                // this.getCompetitiveScore()
              }
              if (this.forecast.property_forecast) {
                this.initialValue = this.forecast.property_forecast.assessed_value
              }

              //get property data
              // if(this.user != null && this.forecast) { // vx: revert here and other places when paywall is back
              if(this.forecast) {
                this.doGetProperty(this.forecast.property_forecast.property_id)
              }
            })
              .catch((error) => {
                this.loading = false
                this.error = error.response.data.errorMessage
              })
          } else if (this.propertyId) {
            var useridentification = ''
            if (this.user) {
              useridentification = this.user.user_id
            }
            this.loading = true
            // axios.get('https://api.honely.com/search/forecast', {
            // axios.get('https://api.honely.com/lookup/forecast', {
            axios.get('https://listhub.honely.com/locate/listhub_forecast', {
              params: {
                property_id: this.propertyId,
                user_id: useridentification,
              },
            }).then((response) => {
              this.loading = false
              this.forecast = response.data
              console.log('vx: zipcode is null!')
              if (this.forecast.zipcode === null) {
                console.log('vx: zipcode is null!')
                bus.$emit('showError', { message: 'Sorry, Forecast Data is currently unavailable for this property!' })
                setTimeout(() => {
                  window.location.href = '/'
                }, 3000)
              }
              this.stateZipCodeRankings=[]
              this.statePropertyValueRankings=[]
              this.nationalZipCodeRankings=[]
              this.nationalPropertyValueRankings=[]
              for(var x=0; x< 4; x++) {
                this.stateZipCodeRankings.push(parseInt(this.forecast.neighborhood.zipcode_growth_state_ranking_forecasts[x].change))
                this.statePropertyValueRankings.push(parseInt(this.forecast.neighborhood.avg_value_state_ranking_forecasts[x].change))
                this.nationalZipCodeRankings.push(parseInt(this.forecast.neighborhood.zipcode_growth_national_ranking_forecasts[x].change))
                this.nationalPropertyValueRankings.push(parseInt(this.forecast.neighborhood.avg_value_national_ranking_forecasts[x].change))
              }
              if (this.forecast.property_forecast.property_id) {
                // this.getCompetitiveScore()
              }
              if (this.forecast.property_forecast) {
                this.initialValue = this.forecast.property_forecast.assessed_value
              }

              //get property data
              // if(this.user != null && this.forecast) {
              if(this.forecast) {
                this.doGetProperty(this.forecast.property_forecast.property_id)
              }
            })
              .catch((error) => {
                this.loading = false
                this.error = error.response.data.errorMessage
              })
          } else if (this.address) {
            var useridentification = null
          if (this.user) {
            useridentification = this.user.user_id
          }
            this.loading = true
            // axios.get('https://api.honely.com/search/forecast', {
            // axios.get('https://api.honely.com/lookup/forecast', {
            axios.get('https://listhub.honely.com/locate/listhub_forecast', {
              params: {
                address: this.address,
                user_id: useridentification,
              },
            }).then((response) => {
              this.loading = false
              // console.log(response.data)
              // console.log('vx: if block of forecast api call this.adresss block 1')
              this.forecast = response.data
              this.stateZipCodeRankings=[]
              this.statePropertyValueRankings=[]
              this.nationalZipCodeRankings=[]
              this.nationalPropertyValueRankings=[]
              for(var x=0; x< 4; x++) {
                this.stateZipCodeRankings.push(parseInt(this.forecast.neighborhood.zipcode_growth_state_ranking_forecasts[x].change))
                this.statePropertyValueRankings.push(parseInt(this.forecast.neighborhood.avg_value_state_ranking_forecasts[x].change))
                this.nationalZipCodeRankings.push(parseInt(this.forecast.neighborhood.zipcode_growth_national_ranking_forecasts[x].change))
                this.nationalPropertyValueRankings.push(parseInt(this.forecast.neighborhood.avg_value_national_ranking_forecasts[x].change))
              }
              // console.log('vx: if block of forecast api call this.adresss block 2')
              // if (this.forecast.property_forecast.property_id) {
              //   // this.getCompetitiveScore()
              //   console.log('vx: if block of forecast api call this.adresss block 3')
              // }
              if (this.forecast.property_forecast) {
                this.initialValue = this.forecast.property_forecast.assessed_value
                // console.log('vx: if block of forecast api call this.adresss block 4')
              }

              //get property data
              // if(this.user != null && this.forecast) {
              if(this.forecast) {
                this.doGetProperty(this.forecast.property_forecast.property_id)
              }
            })
              .catch((error) => {
                this.loading = false
                // console.log('vx: catch block of forecast api call this.adresss block', error=='Error: Request failed with status code 406')
                if(error=='Error: Request failed with status code 404'){
                  bus.$emit('showError', { message: 'We could not find Smart Search results for this area. Please check your spelling or enter a valid ZIP code or address.' })
                  this.$router.push({name : 'Smart Search'})
                }
                this.error = error.response.data.errorMessage
              })
          }
          },500)
          // if (this.fips && this.apn) {
          //   // axios.get('https://api.honely.com/search/forecast', {
          //   axios.get('https://api.honely.com/lookup/forecast', {
          //     params: {
          //       apn: this.apn,
          //       fips: this.fips,
          //       user_id: this.user.user_id,
          //     },
          //   }).then((response) => {
          //     this.forecast = response.data
          //     this.stateZipCodeRankings=[]
          //     this.statePropertyValueRankings=[]
          //     this.nationalZipCodeRankings=[]
          //     this.nationalPropertyValueRankings=[]
          //     for(var x=0; x< 4; x++) {
          //       this.stateZipCodeRankings.push(parseInt(this.forecast.neighborhood.zipcode_growth_state_ranking_forecasts[x].change))
          //       this.statePropertyValueRankings.push(parseInt(this.forecast.neighborhood.avg_value_state_ranking_forecasts[x].change))
          //       this.nationalZipCodeRankings.push(parseInt(this.forecast.neighborhood.zipcode_growth_national_ranking_forecasts[x].change))
          //       this.nationalPropertyValueRankings.push(parseInt(this.forecast.neighborhood.avg_value_national_ranking_forecasts[x].change))
          //     }
          //     if (this.forecast.property_forecast.property_id) {
          //       // this.getCompetitiveScore()
          //     }
          //     if (this.forecast.property_forecast) {
          //       this.initialValue = this.forecast.property_forecast.assessed_value
          //     }
          //   })
          //     .catch((error) => {
          //       this.error = error.response.data.errorMessage
          //     })
          // } else if (this.propertyId) {
          //   // axios.get('https://api.honely.com/search/forecast', {
          //   axios.get('https://api.honely.com/lookup/forecast', {
          //     params: {
          //       property_id: this.propertyId,
          //       user_id: this.user.user_id,
          //     },
          //   }).then((response) => {
          //     this.forecast = response.data
          //     this.stateZipCodeRankings=[]
          //     this.statePropertyValueRankings=[]
          //     this.nationalZipCodeRankings=[]
          //     this.nationalPropertyValueRankings=[]
          //     for(var x=0; x< 4; x++) {
          //       this.stateZipCodeRankings.push(parseInt(this.forecast.neighborhood.zipcode_growth_state_ranking_forecasts[x].change))
          //       this.statePropertyValueRankings.push(parseInt(this.forecast.neighborhood.avg_value_state_ranking_forecasts[x].change))
          //       this.nationalZipCodeRankings.push(parseInt(this.forecast.neighborhood.zipcode_growth_national_ranking_forecasts[x].change))
          //       this.nationalPropertyValueRankings.push(parseInt(this.forecast.neighborhood.avg_value_national_ranking_forecasts[x].change))
          //     }
          //     if (this.forecast.property_forecast.property_id) {
          //       // this.getCompetitiveScore()
          //     }
          //     if (this.forecast.property_forecast) {
          //       this.initialValue = this.forecast.property_forecast.assessed_value
          //     }
          //   })
          //     .catch((error) => {
          //       this.error = error.response.data.errorMessage
          //     })
          // } else if (this.address) {
          //   // axios.get('https://api.honely.com/search/forecast', {
          //   axios.get('https://api.honely.com/lookup/forecast', {
          //     params: {
          //       address: this.address,
          //       user_id: this.user.user_id,
          //     },
          //   }).then((response) => {
          //     // console.log(response.data)
          //     // console.log('vx: if block of forecast api call this.adresss block 1')
          //     this.forecast = response.data
          //     this.stateZipCodeRankings=[]
          //     this.statePropertyValueRankings=[]
          //     this.nationalZipCodeRankings=[]
          //     this.nationalPropertyValueRankings=[]
          //     for(var x=0; x< 4; x++) {
          //       this.stateZipCodeRankings.push(parseInt(this.forecast.neighborhood.zipcode_growth_state_ranking_forecasts[x].change))
          //       this.statePropertyValueRankings.push(parseInt(this.forecast.neighborhood.avg_value_state_ranking_forecasts[x].change))
          //       this.nationalZipCodeRankings.push(parseInt(this.forecast.neighborhood.zipcode_growth_national_ranking_forecasts[x].change))
          //       this.nationalPropertyValueRankings.push(parseInt(this.forecast.neighborhood.avg_value_national_ranking_forecasts[x].change))
          //     }
          //     // console.log('vx: if block of forecast api call this.adresss block 2')
          //     // if (this.forecast.property_forecast.property_id) {
          //     //   // this.getCompetitiveScore()
          //     //   console.log('vx: if block of forecast api call this.adresss block 3')
          //     // }
          //     if (this.forecast.property_forecast) {
          //       this.initialValue = this.forecast.property_forecast.assessed_value
          //       // console.log('vx: if block of forecast api call this.adresss block 4')
          //     }
          //   })
          //     .catch((error) => {
          //       console.log('vx: catch block of forecast api call this.adresss block')
          //       this.error = error.response.data.errorMessage
          //     })
          // }
        }
      },

      doGetProperty (propertyid) {
        // property
        // console.log('getting property data...' + propertyid)
        // console.log('property id: ' + propertyid)
        if(propertyid) {
          axios.get('https://api.honely.com/lookup/listing?property_id=' + propertyid, {
            params: {
            },
          }).then((response) => {
            // console.log(response.data)
            this.property = response.data
            this.getSchoolData(this.property)
            this.getWalkScore(this.property)
            this.getOptionLists()
            // this.getTrendData()
            this.doCountySupportedOptions()
          }).catch((error) => {
            console.log('[ERROR] Failed to fetch property data')
            console.log(error)
          })
        }
      },

      getSchoolData (property) {
        if (property.address.latitude && property.address.longitude) {
          axios.get('https://api.honely.com/lookup/great_schools', {
            params: {
              lat: property.address.latitude,
              lon: property.address.longitude,
            },
          }).then((response) => {
            this.schools = response.data.schools
            if (!Array.isArray(this.schools)) {
              this.schools = [this.schools]
            }
            this.schools = this.schools.splice(0, 10)
            this.schools.forEach(function (school) {
              school.distance = school.distance.toFixed(2)
              school.distanceText = 'mi'
            })
          })
        }
      },
      getWalkScore (property) {
        if (property.address.street_name && property.address.street_suffix && property.address.city && property.address.state && property.address.zip_code && property.address.latitude && property.address.longitude) {
          axios.get('https://api.honely.com/lookup/walk_score', {
            params: {
              address: property.address.street_name + property.address.street_suffix + ',' + property.address.city + ',' + property.address.state + property.address.zip_code,
              lat: property.address.latitude,
              lon: property.address.longitude,
            },
          }).then((response) => {
            this.walkscore = response.data
          })
        }
      },

      getCompetitiveScore () {
        if (this.forecast.property_forecast.property_id) {
          axios.get('https://listhub.honely.com/locate/competitive_score', {
            params: {
              property_id: this.forecast.property_forecast.property_id,
            },
          }).then((response) => {
            // console.log('vx: response.data.competitive_score in getCompetitiveScore method', response.data.competitive_score)
            this.competitive_score = response.data.competitive_score
          })
        }
      },

      getOptionLists () {
        axios.get('https://api.honely.com/lookup/drop_down', {
          params: {
          },
        }).then((response) => {
          // console.log(response.data)
          if (response.data) {
            this.optionLists = response.data
          }
        })
      },
      getTrendData () {
        if(this.forecast && this.forecast.hasOwnProperty('property_forecast') === true){
          axios.get(`https://www.housingalerts.com/api/?key=gogAEOCeebByaHSVEID92JPVcCu5fmyU&resource_type=honely_dataset&zip=${this.forecast.zipcode}&fips=${this.forecast.property_forecast.fips}&state=${this.forecast.state}`, {transformRequest: (data, headers) => {
          delete headers.common['Authorization'];
          },
          }).then((response) => {
            if(response.data.status === "ok"){
                this.rentalTrendData = response.data.data
                // console.log(this.rentalTrendData)
              }
          }).catch((err) => {
              console.log(err)
          })
        }
      },
      doCountySupportedOptions () {
        // console.log(this.property)
        if (this.property) {
          const self = this
          const propertyId = this.property.address.property_id
          const fips = this.property.address.fips
          const zip = this.property.address.zip_code
          const yearBuilt = this.property.structure.year_built

          // reqquest body with default values
          const body = {
            basic_info: {
              property_id: propertyId,
              fips: fips,
              zip: zip,
              year_build: yearBuilt,
            },
            numerical: {
              sqft: '1200',
              num_beds: '3',
              num_baths: '1',
              num_partial_baths: '0',
              room_count: '6',
              parking_spaces: 0,
              plumbing_count: 3,
            },
            category: {
              stories: null,
              other_rooms: null,
              air_condition: null,
              heat_type: null,
              heat_fuel_type: null,
              pool_type: null,
              building_condition: null,
              architecture: null,
              construction: null,
              basement_type: null,
              roof_style: null,
              roof_material_type: null,
              exterior_walls: null,
              interior_walls: null,
              flooring: null,
              garage_type: null,
              water_type: null,
              sewer_type: null,
            },
          }

          const apiURL = 'https://api.honely.com/calculator/honely_calculator'
          // console.log(JSON.stringify(body))

          fetch(apiURL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
          }).then(function (response) {
            // console.log(response)
            return response.json()
          }).then(function (data) {
            // console.log(data)
            if (data) {
              self.countyOptions = data.supported_dropdowns_for_this_county
              self.countyOptionsMulti = data.supported_multi_dropdowns_for_this_county
            }
          }).catch((err) => {
            console.log('[ERROR] Getting county options failed =>', err)
          })
        }
      },
    },
  }
</script>

<style lang="sass">
#forecast-band-1
  .forecast-band-header
    color: $color-emerald
    border-bottom: 2px solid $color-emerald

    span
      color: $color-gray-shadow

  .forecast-band-subheader
    color: $color-gray-shadow

    span
      color: $color-gray-med
      padding-left: 38px

  .current-value-card

    .v-card__title
      display: block
      font-size: 17px
      line-height: 22px

      span
        font-size: 30px
        line-height: 35px
        display: block

      span.value-higher
        color: $color-emerald

      span.value-lower
        color: $color-squash

  .forecast-card
    border: 1px solid $color-emerald
    min-height: 387px

    .v-card__title
      color: $color-orange

      span
        color: $color-gray-shadow
        font-size: 17px
        line-height: 20px
        font-weight: 600

    .v-card__subtitle
      font-weight: 600
      color: $color-gray-dk

    .v-card__subtitle.forecast-data-header
      font-size: 15px
      font-family: $heading-font-family
      letter-spacing: .03em

      span, i
        font-size: 25px
        color: $color-emerald
        padding: 0 3px

    .v-slider__tick-label
      font-size: 12px
      font-weight: 600

    .forecast-data-bar
      background-color: $color-gray-vlt
      border-color: $color-gray-mdlt

      .v-card
        background-color: inherit
        font-size: 14px

        span
          color: $color-emerald
          font-weight: 800

        span.value-lower
          color: $color-squash

  .forecast-data-footer
    .v-card__text
      span
        font-weight: 800
        padding: 0 4px

#forecast-band-2
  background-color: $color-gray-vlt

  .forecast-band-header
    color: $color-emerald
    border-bottom: 2px solid $color-emerald

    span
      color: $color-gray-shadow

  .forecast-band-subheader
    color: $color-gray-shadow

    span
      color: $color-gray-med
      padding-left: 38px

  .v-tab
    // border-left: 1px solid $color-gray-lt
    border-bottom: 1px solid $color-gray-lt
    text-transform: none
    letter-spacing: normal
    font-weight: 600

  .v-tab:nth-child(2)
  // border-left: none

  .v-tab--active
    border-bottom: 1px solid white

  .spacer
    border-bottom: 1px solid $color-gray-lt
  // border-left: 1px solid $color-gray-lt

  .v-tabs-slider-wrapper
    top: 0
    bottom: auto

    .v-card__title
      display: block
      font-size: 17px
      line-height: 22px

      span
        font-size: 30px
        line-height: 35px
        display: block

      span.value-higher
        color: $color-emerald

      span.value-lower
        color: $color-squash

  .forecast-card
    border: 1px solid $color-emerald

    .v-card__title
      color: $color-orange

      span
        color: $color-gray-shadow
        font-size: 17px
        line-height: 20px
        font-weight: 400

    .v-card__title.same-size-span
      span
        font-size: inherit
        padding-left: 6px

    .v-card__subtitle
      font-weight: 600
      color: $color-gray-dk

    .v-card__subtitle.forecast-data-header
      font-size: 15px
      font-family: $heading-font-family
      letter-spacing: .03em

      span, i
        font-size: 25px
        color: $color-emerald
        padding: 0 3px

    .v-slider__tick-label
      font-size: 12px
      font-weight: 600

    .forecast-data-bar
      background-color: $color-gray-vlt
      border-color: $color-gray-mdlt

      .v-card
        background-color: inherit
        font-size: 14px

        span
          color: $color-emerald
          font-weight: 800

        span.value-lower
          color: $color-squash

    .forecast-card-content

      .v-card__subtitle.subtitle-2
        color: $color-emerald
        padding: 0
        margin: 0

      .forecast-text-table
        td
          margin: 0
          padding: 3px 0
          color: $color-gray-shadow

        td:last-child
          font-weight: 600

        td.value-higher
          color: $color-emerald

        td.value-lower
          color: $color-squash

    .forecast-card-content.graph-card
      .v-card__subtitle.subtitle-2
        color: $color-gray-shadow

        i.icon-home-color
          color: #32bebb

  .forecast-data-footer
    .v-card__text
      span
        font-weight: 800
        padding: 0 4px

  .overlay-graph
    position: absolute
    bottom: 20px
    left: 0
    z-index: 10
    width: 100%

  .forecast-big-number-table
    tr:nth-child(even)
      background-color: inherit
    tr:nth-child(odd)
      background-color: $color-gray-vlt2

    td
      border: none
      color: $color-gray-shadow
      font-size: 17px

    td:nth-child(odd)
      font-family: $heading-font-family
      font-weight: 400
      font-size: 25px
      color: $color-emerald

  .forecast-big-number-table.two-groups
    td:nth-child(even)
      font-size: 14px

    td:nth-child(3)
      border-left: 1px solid $color-gray-lt

  .v-card__subtitle.orange-subtitle
    color: $color-orange
    font-size: 17px
    font-weight: 600

    span, span.gray-shadow
      color: $color-gray-shadow

  .forecast-full-width

    .v-card__title.big-then-little
      color: $color-emerald

      span
        font-size: .4em
        padding-left: 8px
        color: $color-gray-shadow
        display: block

    .v-card__subtitle
      span
        padding: 0 4px
        color: $color-gray-mdlt

    .text-h5
      font-weight: 500
      display: block
      line-height: 27px
      color: $color-orange

      span
        color: $color-gray-shadow

    .linear-scale
      span
        display: block
        float: left
        font-weight: 600

      span.text-right
        float: right

    ul

      li
        margin-bottom: 8px
        font-size: 16px
        line-height: 19px
        color: $color-gray-shadow
        padding-left: 10px

        strong
          color: black

      li::marker
        color: $color-emerald-lt
        content: "•"

  .clear-me
    clear: left

  .v-card.market-competition
    background: #fafafa url('~@/assets/bg-competition2.png') no-repeat right top
    background-size: 50%

#forecast-band-3
  background: url('~@/assets/bg-moving.png') no-repeat right center

  .forecast-band-header
    color: $color-emerald
    border-bottom: 2px solid $color-emerald

    span
      color: $color-gray-shadow

  .forecast-band-subheader
    color: $color-gray-shadow

    span
      color: $color-gray-med
      padding-left: 38px

  .current-value-card

    .v-card__title
      display: block
      font-size: 17px
      line-height: 22px

      span
        font-size: 30px
        line-height: 35px
        display: block

      span.value-higher
        color: $color-emerald

      span.value-lower
        color: $color-squash

  .forecast-card
    border: 1px solid $color-emerald

    .v-card__title
      color: $color-orange

      span
        color: $color-gray-shadow
        font-size: 17px
        line-height: 20px
        font-weight: 600

    .v-card__title.same-size-span
      span
        font-size: inherit
        padding-left: 6px

    .v-card__subtitle
      font-weight: 600
      color: $color-gray-dk

    .v-card__subtitle.forecast-data-header
      font-size: 15px
      font-family: $heading-font-family
      letter-spacing: .03em

      span, i
        font-size: 25px
        color: $color-emerald
        padding: 0 3px

      span.value-lower
        color: $color-squash

    .v-slider__tick-label
      font-size: 12px
      font-weight: 600

    .forecast-data-bar
      background-color: $color-gray-vlt
      border-color: $color-gray-mdlt

      .v-card
        background-color: inherit
        font-size: 14px

        span
          color: $color-emerald
          font-weight: 800

        span.value-lower
          color: $color-squash

  .forecast-data-footer
    .v-card__text
      span
        font-weight: 800
        padding: 0 4px

#forecast-band-4
  background-color: white

  .forecast-band-header
    color: $color-emerald
    border-bottom: 2px solid $color-emerald

    span
      color: $color-gray-shadow
      font-weight: 400

  .forecast-band-subheader
    color: $color-gray-shadow

    span
      color: $color-gray-med
      padding-left: 38px

  .current-value-card

    .v-card__title
      font-size: 17px
      line-height: 22px

      span
        font-size: 30px
        line-height: 35px
        font-weight: 400

  .forecast-card
    border: none
    background-color: inherit

    .v-card__title
      color: $color-orange
      font-weight: 500

      span
        color: $color-gray-med
        font-size: 17px
        line-height: 20px
        font-weight: 400
        padding-left: 12px

    .v-card__title.same-size-span
      span
        font-size: inherit
        padding-left: 6px

    .v-card__subtitle
      font-weight: 600
      color: $color-gray-dk

    .v-card__subtitle.forecast-data-header
      font-size: 15px
      font-family: $heading-font-family
      letter-spacing: .03em

      span, i
        font-size: 25px
        color: $color-emerald
        padding: 0 3px

      span.value-lower
        color: $color-squash

  .forecast-big-number-table-alt
    border-bottom: 2px solid $color-orange

    tr:nth-child(even)
      background-color: inherit

    tr:nth-child(odd)
      background-color: white

    td
      color: $color-gray-shadow
      font-size: 20px
      font-weight: 600

    td:nth-child(odd)
      font-family: $heading-font-family
      font-weight: 400
      font-size: 17px
      color: $color-emerald

  .mortgage-calculator

    .v-text-field
      background-color: white
      padding: 18px 12px 12px 12px
      border-radius: 10px

    .v-label
      color: $color-gray-shadow
      font-size: 15px
      font-weight: 600

    .v-label.v-label--active
      color: $color-emerald !important

    .mortgage-submit
      background-color: $color-emerald !important
      font-size: 17px !important
      font-family: "Avant Garde Gothic Md", "lato", sans-serif
      margin-top: 20px

    .mortgage-submit:hover
      background-color: $color-emerald-lt !important

  .v-card__subtitle.orange-subtitle
    color: $color-squash
    background-color: $color-gray-vlt
    font-size: 17px
    font-weight: 600

    span, span.gray-shadow
      color: $color-gray-shadow
#forecast-band-5
  background-color: $color-gray-vlt

  .forecast-band-header
    color: $color-emerald
    border-bottom: 2px solid $color-emerald

    span
      color: $color-gray-shadow
      font-weight: 400

  .forecast-band-subheader
    color: $color-gray-shadow

    span
      color: $color-gray-med
      padding-left: 38px

  .current-value-card

    .v-card__title
      font-size: 17px
      line-height: 22px

      span
        font-size: 30px
        line-height: 35px
        font-weight: 400

  .forecast-card
    border: none
    background-color: inherit

    .v-card__title
      color: $color-orange
      font-weight: 500

      span
        color: $color-gray-med
        font-size: 17px
        line-height: 20px
        font-weight: 400
        padding-left: 12px

    .v-card__title.same-size-span
      span
        font-size: inherit
        padding-left: 6px

    .v-card__subtitle
      font-weight: 600
      color: $color-gray-dk

    .v-card__subtitle.forecast-data-header
      font-size: 15px
      font-family: $heading-font-family
      letter-spacing: .03em

      span, i
        font-size: 25px
        color: $color-emerald
        padding: 0 3px

      span.value-lower
        color: $color-squash

  .forecast-big-number-table-alt
    border-bottom: 3px solid green
    border-radius: 10px

    tr:nth-child(even)
      background-color: inherit
      height: 100px
      border: 1px solid grey
      border-radius: 10px
      height: 87px

    tr:nth-child(odd)
      background-color: inherit
      height: 100px
      border-radius: 10px
      height: 87px
    td
      color: $color-gray-shadow
      font-size: 20px
      font-weight: 600
      border-radius: 10px
      height: 87px

    td:nth-child(odd)
      font-weight: 400
      font-size: 40px
      height: 87px
      text-align: center
      color: black
      background-color: inherit
      border-radius: 10px

#forecast-band-6
  background-color: $color-gray-vlt

  .forecast-band-header
    color: $color-emerald
    border-bottom: 2px solid $color-emerald

    span
      color: $color-gray-shadow
      font-weight: 400

  .forecast-band-subheader
    color: $color-gray-shadow

    span
      color: $color-gray-med
      padding-left: 38px

  .current-value-card

    .v-card__title
      font-size: 17px
      line-height: 22px

      span
        font-size: 30px
        line-height: 35px
        font-weight: 400

  .forecast-card
    border: none
    background-color: inherit

    .v-card__title
      color: $color-orange
      font-weight: 500

      span
        color: $color-gray-med
        font-size: 17px
        line-height: 20px
        font-weight: 400
        padding-left: 12px

    .v-card__title.same-size-span
      span
        font-size: inherit
        padding-left: 6px

    .v-card__subtitle
      font-weight: 600
      color: $color-gray-dk

    .v-card__subtitle.forecast-data-header
      font-size: 15px
      font-family: $heading-font-family
      letter-spacing: .03em

      span, i
        font-size: 25px
        color: $color-emerald
        padding: 0 3px

      span.value-lower
        color: $color-squash

  .forecast-big-number-table-alt
    border-bottom: 3px solid green
    border-radius: 10px

    tr:nth-child(even)
      background-color: inherit
      height: 100px
      border: 1px solid grey
      border-radius: 10px
      height: 87px

    tr:nth-child(odd)
      background-color: inherit
      height: 100px
      border-radius: 10px
      height: 87px
    td
      color: $color-gray-shadow
      font-size: 20px
      font-weight: 600
      border-radius: 10px
      height: 87px

    td:nth-child(odd)
      font-weight: 400
      font-size: 40px
      height: 87px
      text-align: center
      color: black
      background-color: inherit
      border-radius: 10px

#forecast-band-7
  background-color: white
  .forecast-band-header
    color: $color-emerald
    border-bottom: 2px solid $color-emerald

    span
      color: $color-gray-shadow
      font-weight: 400

  .forecast-band-subheader
    color: $color-gray-shadow

    span
      color: $color-gray-med
      padding-left: 38px

  .current-value-card

    .v-card__title
      font-size: 17px
      line-height: 22px

      span
        font-size: 30px
        line-height: 35px
        font-weight: 400

  .forecast-card
    border: none
    background-color: inherit

    .v-card__title
      color: $color-orange
      font-weight: 500

      span
        color: $color-gray-med
        font-size: 17px
        line-height: 20px
        font-weight: 400
        padding-left: 12px

    .v-card__title.same-size-span
      span
        font-size: inherit
        padding-left: 6px

    .v-card__subtitle
      font-weight: 600
      color: $color-gray-dk

    .v-card__subtitle.forecast-data-header
      font-size: 15px
      font-family: $heading-font-family
      letter-spacing: .03em

      span, i
        font-size: 25px
        color: $color-emerald
        padding: 0 3px

      span.value-lower
        color: $color-squash

  .forecast-big-number-table-alt
    border-bottom: 2px solid $color-orange

    tr:nth-child(even)
      background-color: inherit

    tr:nth-child(odd)
      background-color: white

    td
      color: $color-gray-shadow
      font-size: 20px
      font-weight: 600

    td:nth-child(odd)
      font-family: $heading-font-family
      font-weight: 400
      font-size: 17px
      color: $color-emerald
</style>
<style lang="css">
.forecast-section-below-heading {
  padding-top: 2rem;
}
.forecast-band-header span i {
  color: #07871c;
}
.row-2cols{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.row-2cols .col {
  background: #ffffff;
  width: 48%;
  padding: 2rem 1rem 1rem 1rem;
  flex-basis: initial;
  flex-grow: initial;
  border: 1px solid #07871c;
  border-radius: 4px;
  box-shadow: 0px 4px 5px -2px rgb(0 0 0 / 20%), 0px 7px 10px 1px rgb(0 0 0 / 14%), 0px 2px 16px 1px rgb(0 0 0 / 12%) !important;
}
.col-row {
  width: 100%;
}
.competitive-price {
  text-align: center;
}
.competitive-price .col-row:first-of-type {
  padding-bottom: 3.5rem;
}
.col-row label {
  display: block;
  font-size: 24px;
  font-weight: bold;
}
.competitive-score-section input{
  font-size: 35px;
  text-align: center;
  padding: 30px 0 !important;
}
.competitive-price span{
  font-size: 38px;
  font-weight: bold;
  color: #07871c;
}
.competitive-price .v-text-field{
  background: transparent !important;
}
.competitive-score{
  text-align: center;
}
.competitive-score label{
  display: block;
  font-size: 24px;
  font-weight: bold;
  padding-bottom: 1rem;
}
.competitive-score span{
    font-size: 80px;
    font-weight: bold;
}
@media only screen and (max-width: 700px){
  .v-application .text-h4 {
    font-size: 1.25rem !important;
  }
  #forecast-band-1 .forecast-band-subheader span {
    padding-left: 0;
    display: block;
  }
}
@media only screen and (max-width: 500px){
  .forecast-band-header span i {
    font-size: 24px;
    vertical-align: bottom;
  }
  .forecast-section-below-heading {
    padding-top: 1rem;
  }
  .row-2cols {
    display: block;
  }
  .row-2cols .col{
    width: 100%;
    margin-bottom: 1rem;
  }
  .competitive-score label{
    padding-bottom: 0;
  }
  .v-application .text-h4 {
    font-size: 18px !important;
  }
  .competitive-score-section input{
    max-height: initial !important;
    padding: 10px 0 !important;
    line-height:  140% !important;
    height: 70px !important;
  }
}
</style>
